var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingMeetingsClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.704,
    height: 16.704,
    viewBox: "0 0 16.704 16.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-4.001 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54477",
    "data-name": "Path 54477",
    d: "M9.352,1A8.352,8.352,0,1,0,17.7,9.352,8.352,8.352,0,0,0,9.352,1Zm2.815,11.167a.759.759,0,0,1-1.074,0L8.815,9.889a.759.759,0,0,1-.222-.537V4.8a.759.759,0,1,1,1.519,0V9.038l2.055,2.055A.759.759,0,0,1,12.167,12.167Z",
    transform: "translate(3.001 13)",
    fill: "#9c9c9c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingMeetingsClock);
export default __webpack_public_path__ + "static/media/upcoming-meetings-clock.833729e375919f083017ef8c7e72a13f.svg";
export { ForwardRef as ReactComponent };